import { useAuthStore } from "@/store/auth";
import Payments from "./payments";
import invoices from "./invoices";
import students from "./students";
import faculties from "./faculties";
import departments from "./departments";
import yearRoute from "./yearRoute";
import programs from "./programs";
import levelsRoute from "./levelsRoute";
import staffRoute from "./staffRoute";
import rolesRoute from "./rolesRoute";
import feeRoute from "./feeRoute";
import studentCategoriesRoute from "./studentCategoriesRoute";
import courseRoute from "./courseRoute";
import semesterRoute from "./semesterRoute";
import courseRegRoute from "./courseRegRoute";
import userRoute from "./userRoute";
import transactionRoute from "./transactionRoute";
import examCardRoute from "./examCardRoute";
import assignedcourseRoute from "./assignedcourseRoute.js";
import departmentComment from "./departmentComment.js";
import courseComment from "./courseComment.js";
import traitRoute from "./traitRoute.js";
import parentRoute from "./parentRoute.js";
import assignedLevels from "./assignedlevelsRoute.js";
import migrationsRoute from "./migrationsRoute.js";
import resultRoute from "./resultRoute.js";
import graduationRoute from "./graduationRoute.js";
import scoresRoute from "./scoresRoute.js";
import attendanceRoute from "./attendanceRoute.js";
import calendarRoute from './calendarRoute.js'
import facultyGrades from "./facultyGrades.js";
import assetsManagementRoute from './assetsRoute.js'
import gradesRoute from "./gradesRoute.js";
import traitsTypesRoute from './traitTypeRoute.js'
import speadsheetRoute from "./speadsheetRoute.js";
import accountRoute from "./accountRoute.js";
export default [
  ...accountRoute,
  ...assignedLevels,
  ...assetsManagementRoute,
  ...calendarRoute,
  ...attendanceRoute,
  ...scoresRoute,
  ...graduationRoute,
  ...resultRoute,
  ...Payments,
  ...invoices,
  ...students,
  ...faculties,
  ...departments,
  ...yearRoute,
  ...programs,
  ...levelsRoute,
  ...staffRoute,
  ...rolesRoute,
  ...feeRoute,
  ...studentCategoriesRoute,
  ...courseRoute,
  ...semesterRoute,
  ...courseRegRoute,
  ...userRoute,
  ...transactionRoute,
  ...examCardRoute,
  ...assignedcourseRoute,
  ...traitRoute,
  ...parentRoute,
  ...migrationsRoute,
  ...facultyGrades,
  ...departmentComment,
  ...courseComment,
  ...gradesRoute,
  ...traitsTypesRoute,
  ...speadsheetRoute,
  {
    path: "/",
    name: "login",
    component: () => import("@/views/auth/login.vue"),
    meta: {
      title: "Login",
      // beforeResolve(routeTo, routeFrom, next) {
      //   // If the user is already logged in
      //   if (useAuthStore().isLoggedIn) {
      //     // Redirect to the home page instead
      //     next({ name: "dashboard" });
      //   } else {
      //     // Continue to the login page
      //     next();
      //   }
      // },
    },
  },
  {
    path: "/c",
    name: "cover",
    component: () => import("@/views/auth/cover.vue"),
    meta: {
      title: "Login",

    },
  },
  {
    path: "/NlPagok8MsIz",
    name: "Register",
    component: () => import("@/views/auth/register.vue"),
    meta: {
      title: "Register",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (useAuthStore().isLoggedIn) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/tGA1124i58YX",
    name: "Forgot password",
    component: () => import("@/views/auth/reset-password.vue"),
    meta: {
      title: "Forgot Password",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (useAuthStore().isLoggedIn) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/pEG8A1krFX",
    name: "dashboard",
    meta: {
      title: "Dashboard",
      authRequired: true,
      // beforeResolve(routeTo, routeFrom, next) {
      //   next({name: "default" });
      // },
    },
    component: () => import("@/views/dashboard/dashboard"),
  },
  {
    path: "/pEG8Aed1fd89c95bea3547264efe41krFX",
    name: "assets-dash",
    meta: {
      title: "Dashboard",
      authRequired: true,
      // beforeResolve(routeTo, routeFrom, next) {
      //   next({name: "default" });
      // },
    },
    component: () => import("@/views/dashboard/assets/index.vue"),
  },
  {
    path: "/d2f302a395b1ad0e235ae9a7",
    name: "students.analysis",
    meta: {
      title: "Dashboard",
      authRequired: true,
      // beforeResolve(routeTo, routeFrom, next) {
      //   next({name: "default" });
      // },
    },
    component: () => import("@/views/dashboard/assets/analysis.vue"),
  },
  {
    path: "/pEG8Aed35bb6986e7c106b1e6d7ae1krFX",
    name: "attendance-dashboard",
    meta: {
      title: "Attendance Dashboard",
      authRequired: true,
      // beforeResolve(routeTo, routeFrom, next) {
      //   next({name: "default" });
      // },
    },
    component: () => import("@/views/dashboard/attendance/index.vue"),
  },
  {
    path: "/pEG8A1krFXy609..",
    name: "reset-password",
    meta: {
      title: "Reset Password",
      authRequired: true,
    },
    component: () => import("@/views/auth/reset-password.vue"),
  },
  {
    path: "/cgvzl96QF9zV1ylVYK3U",
    name: "default",
    meta: {
      title: "Dashboard",
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        next({ name: "dashboard" });
        // Continue to the login page
      },
    },
    component: () => import("@/views/dashboard/default.vue"),
  },
  {
    path: "/cgvzl96QF9zV1ylVYK3U&ITYHGTH",
    name: "staff-default",
    meta: {
      title: "Dashboard",
      authRequired: true,
    },
    component: () => import("@/views/dashboard/staff-dashboard.vue"),
  },
  {
    path: "/cgvzl96QF9zV1ylVYK3U%FEFF",
    name: "section-default",
    meta: {
      title: "Dashboard",
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        next({ name: "dashboard" });
        // Continue to the login page
      },
    },
    component: () => import("@/views/dashboard/section-head.vue"),
  },
  {
    path: "/XmyeVqbZfhIdxAqw78QX/:menu",
    name: "menu",
    meta: {
      title: "Menu List",
      authRequired: true,
      // acc: "admin",
    },
    component: () => import("@/views/settings/menu-list"),
  },
  {
    path: "/ZfhIdxA",
    name: "account-dashboard",
    meta: {
      title: "Account Dashboard",
      authRequired: true,
      acc: ["y93422"],
    },
    component: () => import("@/views/dashboard/account/account-dashboard.vue"),
  },

  {
    path: "/ngihfnefywu09nrr8wrr",
    name: "appInfo",
    meta: {
      title: "Update Application Information",
      authRequired: true,
    },
    component: () => import("@/views/settings/appInfo/new.vue"),
  },

  {
    path: "/notfound",
    name: "notfound",
    meta: {
      title: "404",
      //
    },
    component: () => import("@/views/notfound/404-cover"),
  },
  // start of import
  {
    path: "/:pathMatch(.*)*",
    name: "not-found",
    meta: {
      title: "404",
      //
    },
    component: () => import("@/views/notfound/404-cover"),
  },
  // end of import
];
